import React, { useContext } from 'react'
import { ScreeningSectionsContext } from 'src/mentor/components/PrescriptionMakingPage/context/ScreeningSectionsProvider'
import ScreeningReportDisplay from 'src/mentor/components/PrescriptionMakingPage/screeningReportViewer/ScreeningReportDisplay'

export default function ScreeningReportDrawerComponent({
  auxiliaryData,
  bookedEventInfo,
  mentorProfileData,
}) {
  const { screeningSections } = useContext(ScreeningSectionsContext)
  return (
    <ScreeningReportDisplay
      reportData={auxiliaryData?.screeningReport}
      screeningSections={screeningSections}
      screeningReportTemplateData={auxiliaryData?.screeningReportTemplate}
      emrSectionDataList={auxiliaryData?.['screening__EmrSectionData']}
      bookedEventInfo={bookedEventInfo}
      mentorProfileData={mentorProfileData}
      bottomBorderBorderModifier="1px solid #000"
    />
  )
}
